import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "form-contents" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_12 = { class: "bottom10" };
const _hoisted_13 = { class: "invalid-feedback" };
const _hoisted_14 = { class: "bottom10" };
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = { class: "bottom10" };
const _hoisted_17 = { class: "invalid-feedback" };
const _hoisted_18 = { class: "checkbox-wrapper" };
const _hoisted_19 = { class: "checkbox-wrapper" };
const _hoisted_20 = { class: "checkbox-wrapper" };
const _hoisted_21 = { class: "checkbox-wrapper" };
const _hoisted_22 = { class: "ms-4" };
const _hoisted_23 = { class: "invalid-feedback" };
const _hoisted_24 = { class: "checkbox-wrapper" };
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_26 = { class: "d-flex mb-2" };
const _hoisted_27 = { class: "d-flex mb-1" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "font-weight-normal" };
const _hoisted_32 = { class: "d-flex justify-content-between" };
const _hoisted_33 = { class: "d-flex" };
const _hoisted_34 = { class: "d-flex align-items-end" };
const _hoisted_35 = ["disabled"];
const _hoisted_36 = ["disabled"];
const _hoisted_37 = {
    class: "list-filter",
    style: { "height": "415px", "overflow-x": "auto", "border": "1px solid black", "background-color": "whitesmoke" }
};
const _hoisted_38 = { class: "list-options" };
const _hoisted_39 = ["title", "onClick"];
const _hoisted_40 = { style: { "font": "700", "font-size": "16px" } };
const _hoisted_41 = { class: "col-xs-12 col-sm-12 col-md-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_ContactsVue = _resolveComponent("ContactsVue");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _directive_cloud_only = _resolveDirective("cloud-only");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isEventTypeArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing event type name...'), 3 /* TEXT, CLASS */)
            ]),
            _cache[22] || (_cache[22] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _ctx.archive
                    }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Archive", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewEventType && !_ctx.isEventTypeArchived]
                    ]),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "warning",
                        onClick: _ctx.restore
                    }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Restore", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewEventType && _ctx.isEventTypeArchived]
                    ]),
                    _cache[21] || (_cache[21] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[72] || (_cache[72] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _cache[71] || (_cache[71] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _cache[23] || (_cache[23] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[24] || (_cache[24] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                maxlength: "150",
                                                modelValue: _ctx.eventType.eventTypeName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.eventType.eventTypeName) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[25] || (_cache[25] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_13, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a event name.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _cache[41] || (_cache[41] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_14, [
                                            _cache[27] || (_cache[27] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tScope *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[28] || (_cache[28] = _createTextVNode()),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.scopeVal, {
                                                modelValue: _ctx.eventScope,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.eventScope) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: _ctx.selectPlaceholder,
                                                options: _ctx.eventScopes,
                                                showLabels: false,
                                                class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.scope }
                                            }), {
                                                noResult: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                            _cache[29] || (_cache[29] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please select an event scope\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.scope]
                                            ])
                                        ]),
                                        _cache[42] || (_cache[42] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_16, [
                                            _cache[30] || (_cache[30] = _createElementVNode("label", null, [
                                                _createTextVNode("Time Window (minutes) "),
                                                _createElementVNode("i", {
                                                    class: "fa fa-question-circle-o",
                                                    "aria-hidden": "true",
                                                    title: "This is the time period over which the defined alarms will be grouped as a single event. The period is measured from the last alarm raise time. A new event will be created if an alarm is raised after this time."
                                                })
                                            ], -1 /* CACHED */)),
                                            _cache[31] || (_cache[31] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.timeWindowVal, {
                                                modelValue: _ctx.eventType.timeWindowMinutes,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.eventType.timeWindowMinutes) = $event)),
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                max: "1440",
                                                class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.timeWindow }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_17, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a value between 0 and 1,440 Minutes.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.timeWindow]
                                            ])
                                        ]),
                                        _cache[43] || (_cache[43] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.enabled,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.eventType.enabled) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tEnabled\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendEmail,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.eventType.sendEmail) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend Email\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendSms,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.eventType.sendSms) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend SMS\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ])), [
                                            [_directive_cloud_only]
                                        ]),
                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendNotificationsOnFirstAlarm,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.eventType.sendNotificationsOnFirstAlarm) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend notifications when first alarm is raised\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_22, [
                                            _cache[37] || (_cache[37] = _createElementVNode("label", null, [
                                                _createTextVNode("Minimum alarm duration before sending notification (minutes) "),
                                                _createElementVNode("i", {
                                                    class: "fa fa-question-circle-o",
                                                    "aria-hidden": "true",
                                                    title: "The minimum duration for which the first alarm must be raised before sending notifications. If the alarm duration is less than this value, no notification will be sent. A value of '0' means the notification will be sent immediately."
                                                })
                                            ], -1 /* CACHED */)),
                                            _cache[38] || (_cache[38] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.minEventDurationVal, {
                                                modelValue: _ctx.eventType.minEventDuration,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.eventType.minEventDuration) = $event)),
                                                type: "number",
                                                step: "1",
                                                min: "0",
                                                max: "1440",
                                                class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.minEventDuration },
                                                disabled: !_ctx.eventType.sendNotificationsOnFirstAlarm
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "disabled"]),
                                            _cache[39] || (_cache[39] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_23, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a value between 0 and 60 Minutes.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.timeWindow]
                                            ])
                                        ]),
                                        _cache[48] || (_cache[48] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_b_form_checkbox, {
                                                modelValue: _ctx.eventType.sendNotificationsAfterTimeWindow,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.eventType.sendNotificationsAfterTimeWindow) = $event)),
                                                size: "lg"
                                            }, {
                                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tSend notifications when time window ends\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue"])
                                        ])
                                    ]),
                                    _cache[69] || (_cache[69] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "clearfix" }, [
                                            _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tGroup Alarm Definition(s)\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ], -1 /* CACHED */)),
                                        _cache[65] || (_cache[65] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.alarmType,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.alarmType) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: "Any alarm type",
                                                options: _ctx.alarmTypeOptionsVisible,
                                                showLabels: false
                                            }, {
                                                noResult: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"]),
                                            _cache[51] || (_cache[51] = _createTextVNode()),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.alarmTypeId = null))
                                            }, {
                                                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                                        _createElementVNode("span", { class: "hidden-xs" }, "Reset", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _cache[66] || (_cache[66] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_27, [
                                            _createVNode(_component_multiselect, {
                                                ref: "alarmSeverityOptions",
                                                id: "alarmSeverityFilter",
                                                name: "alarmSeverityOptions",
                                                options: _ctx.alarmSeverities,
                                                multiple: true,
                                                showLabels: false,
                                                preserveSearch: true,
                                                closeOnSelect: false,
                                                placeholder: "",
                                                "track-by": "value",
                                                label: "text",
                                                class: "multiselect-small",
                                                disabled: _ctx.working
                                            }, {
                                                noResult: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                    ]))]),
                                                placeholder: _withCtx(() => [
                                                    (!_ctx.numberOfSeletedAlarmSeverities)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                selection: _withCtx(({ search, isOpen }) => [
                                                    (_ctx.numberOfSeletedAlarmSeverities && !isOpen)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.alarmSeverityOptionText), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                option: _withCtx((props) => [
                                                    _createElementVNode("div", {
                                                        onClick: _withModifiers(($event) => (_ctx.selectSeverity(props.option)), ["stop"])
                                                    }, [
                                                        (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                                            id: 'severity-' + props.option.value,
                                                            checked: props.option.selected,
                                                            key: _ctx.getAlarmSeverityFilter(props.option)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("label", _hoisted_31, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                                                    ], 8 /* PROPS */, _hoisted_30)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["options", "disabled"]),
                                            _cache[57] || (_cache[57] = _createTextVNode()),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: _cache[11] || (_cache[11] = ($event) => ((_ctx.alarmSeverities.forEach(item => item.selected = true))))
                                            }, {
                                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                                        _createElementVNode("span", { class: "hidden-xs" }, "Reset", -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _cache[67] || (_cache[67] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _createVNode(_component_b_button, {
                                                    class: "me-2",
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.selectAllAlarmDefinitions
                                                }, {
                                                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                                            _createElementVNode("span", { class: "hidden-xs" }, "Select All", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"]),
                                                _cache[60] || (_cache[60] = _createTextVNode()),
                                                _createVNode(_component_b_button, {
                                                    type: "button",
                                                    variant: "primary",
                                                    onClick: _ctx.unselectAllAlarmDefinitions
                                                }, {
                                                    default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                                            _createElementVNode("span", { class: "hidden-xs" }, "Unselect All", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["onClick"])
                                            ]),
                                            _cache[63] || (_cache[63] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("label", null, "Selected: " + _toDisplayString(_ctx.selectedAlarmsCount()), 1 /* TEXT */),
                                                _cache[61] || (_cache[61] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input ms-3",
                                                    style: { "margin-bottom": "11px" },
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.showOnlyAlarmsSelected) = $event)),
                                                    disabled: (_ctx.selectedAlarmsCount() == 0)
                                                }, null, 8 /* PROPS */, _hoisted_35), [
                                                    [_vModelCheckbox, _ctx.showOnlyAlarmsSelected]
                                                ]),
                                                _cache[62] || (_cache[62] = _createTextVNode()),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    disabled: _ctx.selectedAlarmsCount() == 0
                                                }, " Show only selected", 8 /* PROPS */, _hoisted_36)
                                            ])
                                        ]),
                                        _cache[68] || (_cache[68] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarmDefinitionOptionsVisible, (item) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(['list-option', _ctx.isAlarmSelected(item) ? 'selected-option' : '', _ctx.isAlarmInUse(item) ? 'in-use-option' : '']),
                                                        title: _ctx.getAlarmDefnitionTitle(item),
                                                        onClick: _withModifiers((event) => _ctx.selectAlarm(item, event), ["prevent"]),
                                                        style: { "text-align": "left", "padding": "5px" }
                                                    }, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("span", _hoisted_40, _toDisplayString(item.text), 1 /* TEXT */)
                                                        ])
                                                    ], 10 /* CLASS, PROPS */, _hoisted_39));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])
                                        ])
                                    ])
                                ]),
                                _cache[70] || (_cache[70] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_41, [
                                    _createVNode(_component_ContactsVue, {
                                        companyId: _ctx.companyId,
                                        filterOnlyContactsWithEmail: false,
                                        isReport: false,
                                        contactIds: _ctx.eventType.contactIds,
                                        "onUpdate:contactIds": _cache[13] || (_cache[13] = ($event) => ((_ctx.eventType.contactIds) = $event)),
                                        contactGroupIds: _ctx.eventType.contactGroupIds,
                                        "onUpdate:contactGroupIds": _cache[14] || (_cache[14] = ($event) => ((_ctx.eventType.contactGroupIds) = $event))
                                    }, null, 8 /* PROPS */, ["companyId", "contactIds", "contactGroupIds"])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
